import {
  SeasonEligibility,
  So5LeaderboardSeasonality,
  Sport,
} from '#src/__generated__/globalTypes.ts';
import { useEnableSorare27Nav } from '#src/hooks/useEnableSorare27Nav.ts';
import type { Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

import { AllSeasons2026 } from './AllSeasons.tsx';
import { InSeason2026, InSeason2027 } from './InSeason.tsx';

const IconBySeasonalityBySport = {
  [Sport.FOOTBALL]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2026,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2026,
    [SeasonEligibility.CLASSIC]: AllSeasons2026,
  },
  [Sport.NBA]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2026,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2026,
    [SeasonEligibility.CLASSIC]: AllSeasons2026,
  },
  [Sport.BASEBALL]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2026,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2026,
    [SeasonEligibility.CLASSIC]: AllSeasons2026,
  },
};

const IconBySeasonalityBySport2027 = {
  [Sport.FOOTBALL]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2026,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2027,
    [SeasonEligibility.CLASSIC]: AllSeasons2026,
  },
  [Sport.NBA]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2026,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2027,
    [SeasonEligibility.CLASSIC]: AllSeasons2026,
  },
  [Sport.BASEBALL]: {
    [So5LeaderboardSeasonality.ALL_SEASONS]: AllSeasons2026,
    [So5LeaderboardSeasonality.IN_SEASON]: InSeason2027,
    [SeasonEligibility.CLASSIC]: AllSeasons2026,
  },
};

type Props = {
  sport: Sport;
  seasonality: So5LeaderboardSeasonality | SeasonEligibility;
  color?: Color;
  size?: Unit;
};

export const SeasonalityIcon = ({
  sport,
  seasonality,
  size = 2,
  color,
}: Props) => {
  const sorare27Enabled = useEnableSorare27Nav();
  const Component = sorare27Enabled
    ? IconBySeasonalityBySport2027[sport][seasonality]
    : IconBySeasonalityBySport[sport][seasonality];
  return <Component size={size} color={color} />;
};
